var _polygon, _polygon2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon3, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ecommerce copia 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "59.51 41.67 92.88 7.11 92.88 48.56 79.88 62.03 59.51 41.67",
    fill: "#e1f6fa"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "61 7.11 61 31.11 50 21.11 39 31.11 39 7.11 61 7.11",
    fill: "#9ae3f0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91,84.11H64.64v-2H91a1,1,0,0,0,1-1V48h2V81.11A3,3,0,0,1,91,84.11Z",
    fill: "#495771"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9,90a6.46,6.46,0,0,1-3.41-.95,6.75,6.75,0,0,1-2.92-4A3,3,0,0,1,25.79,83c0.08-.15.16-0.26,0.23-0.38l0.14-.2c2.22-3.18,9.86-14.07,14.7-20.74l1.62,1.17C37.65,69.49,30,80.37,27.8,83.54l-0.13.19-0.11.18a1,1,0,0,0-.06.69,4.67,4.67,0,0,0,2,2.77,4.75,4.75,0,0,0,3.62.5,1,1,0,0,0,.6-0.42L43.3,73.37,45,74.49,35.42,88.55a3,3,0,0,1-1.8,1.26A7.33,7.33,0,0,1,31.9,90Z",
    fill: "#495771"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.21,92.49a5.78,5.78,0,0,1-3.14-.91,6,6,0,0,1-2.65-4.82l2,0v0a4,4,0,0,0,1.74,3.14,3.88,3.88,0,0,0,3.83.16,0.84,0.84,0,0,0,.32-0.32L50,77.65l1.69,1.07L44,90.83a2.82,2.82,0,0,1-1.11,1A5.94,5.94,0,0,1,40.21,92.49Z",
    fill: "#495771"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.64,93.73A5.6,5.6,0,0,1,45.81,93a6,6,0,0,1-2.76-3.83l2-.44a3.73,3.73,0,0,0,4.62,2.9,0.94,0.94,0,0,0,.57-0.43l5.87-9.62,1.71,1L51.9,92.23a3,3,0,0,1-1.82,1.33A6.53,6.53,0,0,1,48.64,93.73Z",
    fill: "#495771"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57,93.89a5.16,5.16,0,0,1-5.15-4.95,1,1,0,0,1,1-1,1,1,0,0,1,1,1,3.17,3.17,0,0,0,4.42,2.77,0.94,0.94,0,0,0,.47-0.44L72.59,64.27a1,1,0,1,1,1.78.92L60.49,92.1A3,3,0,0,1,59,93.47,5.26,5.26,0,0,1,57,93.89Z",
    fill: "#495771"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.46,84.11H9a3,3,0,0,1-3-3v-72a3,3,0,0,1,3-3H93a1,1,0,1,1,0,2H9a1,1,0,0,0-1,1v72a1,1,0,0,0,1,1H26.46A1,1,0,1,1,26.46,84.11Z",
    fill: "#495771"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.77,68q-0.34,0-.68,0A8.74,8.74,0,0,1,25,64.31a1,1,0,0,1,.26-1.39L41.12,52.1a15.93,15.93,0,0,1,9-2.78l8.25-.62a1,1,0,1,1,.15,2l-8.32.62a14,14,0,0,0-8,2.44L27.26,64a6.36,6.36,0,0,0,4,2.06,6,6,0,0,0,3.09-.58l6.8-4.06a1,1,0,0,1,1,1.72L35.3,67.2A8.11,8.11,0,0,1,31.77,68Z",
    fill: "#495771"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.43,68.08l-2.66-2.65-18-18,5.25-5.26,0.77,0.65,0.7,0.71-3.89,3.9L75.41,65.23,92.16,47.87a1,1,0,0,1,1.44,1.38l-1.4,1.46Z",
    fill: "#495771"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "79.13 62.7 58.1 41.69 92.16 6.42 93.6 7.81 60.91 41.66 61.46 42.2 80.55 61.29 79.13 62.7",
    fill: "#495771"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.8d45ac096fbdfa5224c2ce3cfb9beec1.svg";
export { ForwardRef as ReactComponent };